import { render } from "./activityScale.vue?vue&type=template&id=3264335d&scoped=true"
import script from "./activityScale.vue?vue&type=script&lang=js"
export * from "./activityScale.vue?vue&type=script&lang=js"

import "./activityScale.vue?vue&type=style&index=0&id=3264335d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3264335d"]])

export default __exports__